import { useEffect, useRef, useState } from 'react';
import { Typography, makeStyles } from "@material-ui/core";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
// import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from "react-router-dom";
import ListaVazia from "../../../../../utils/listaVazia";
import { Button, Dialog, DialogTitle, IconButton } from "@mui/material";
import OpenInFullOutlinedIcon from '@mui/icons-material/OpenInFullOutlined';
import CloseFullscreenOutlinedIcon from '@mui/icons-material/CloseFullscreenOutlined';
import Date from '../../../../../utils/date';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import AddCategoriaProducto from '../produto/addCategoriaProducto';
import AddTeorBaseProducto from '../produto/addTeorBaseProducto';
import AtribuicaoQuota from '../produto/atribuicaoQuota';
import api from '../../../../../services/api';
import { useDispatch, useSelector } from 'react-redux';
import LoadingShort from '../../../../../load/loadingShort';
import { temPermissao } from '../../../../../utils/permissoes';


const useStyles = makeStyles((theme) => ({
    hover: { '&:hover': { backgroundColor: '#85287d8a' } },
    /* Estilo para a div fullscreen */
    fullscreenDiv: {
        // display: 'none',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fff',
        color: '#000',
        width: '100%',
        height: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        textAlign: 'center',
        transition: 'all 0.3s ease-in-out'
    },
    /* Quando ativa, a div aparece */
    fullscreenDivActive: {
        display: 'flex'
    },

}))

export default function ItensFactura({ itens, importacaoId, solicitacao, admin = false }) {
    const user = useSelector(state => state.account.user);
    const alert = useSelector(state => state.alert.data);
    const classes = useStyles()
    const navigate = useNavigate()
    const fullscreenDivRef = useRef(null); // Referência para a div que irá para fullscreen
    const [isFullscreen, setIsFullscreen] = useState(false); // Estado para controlar o modo tela cheia
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [modal, setModal] = useState(false);
    const [load, setLoad] = useState(false);
    const dispatch = useDispatch()

    const handleClose = () => { setModal(false); }

    // FECHAR O MODAL ASSIM QUE ALGUM EDITAR ITENS FOR EXECUTADO
    useEffect(() => {
        setModal(false);
    }, [alert]);

    const handleApproveProducto = (productoId) => {
        setLoad(productoId)
        api.post('producto/approve/importacao', {
            solicitacaoImportacaoId: importacaoId,
            productoId: productoId,
            userId: user?._id
        }).then(response => {
            dispatch({
                type: 'alert',
                payload: { alert: 'Produto aprovado com sucesso' },
            });
        }).catch(error => {
            // console.log(error)
            // setMessageError(error.response.data.message)
            dispatch({
                type: 'alert',
                payload: { alert: error.response.data.message },
            });
        }).finally(() => setLoad(false))
    }

    // Função para entrar no modo fullscreen
    const openFullscreen = () => {
        if (fullscreenDivRef.current.requestFullscreen) {
            fullscreenDivRef.current.requestFullscreen();
        } else if (fullscreenDivRef.current.webkitRequestFullscreen) {
            // Suporte para Safari
            fullscreenDivRef.current.webkitRequestFullscreen();
        } else if (fullscreenDivRef.current.msRequestFullscreen) {
            // Suporte para IE11
            fullscreenDivRef.current.msRequestFullscreen();
        }
        setIsFullscreen(true); // Atualiza o estado
    };

    // Função para sair do modo fullscreen
    const closeFullscreen = () => {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
        setIsFullscreen(false); // Atualiza o estado
    };

    // Detecta a tecla Esc para sair do modo fullscreen
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && isFullscreen) {
                closeFullscreen();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isFullscreen]); // Reexecuta o useEffect quando isFullscreen muda 

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <TableContainer ref={fullscreenDivRef} className={`${isFullscreen ? classes.fullscreenDiv : ''}`}>

            {isFullscreen ?
                <small>
                    Sair do Modo Tela Cheia
                    <IconButton color='secondary' onClick={closeFullscreen}> <CloseFullscreenOutlinedIcon fontSize='small' /> </IconButton>
                </small>
                :
                <small>
                    Abrir em Tela Cheia
                    <IconButton color='secondary' onClick={openFullscreen}> <OpenInFullOutlinedIcon fontSize='small' /> </IconButton>
                </small>
            }

            {itens && (
                <>
                    <Table id="myTable" size="small" aria-label="sticky table">
                        <TableHead >
                            <TableRow>
                                {admin && <TableCell ><Typography noWrap> <strong>VISÃO GERAL </strong></Typography></TableCell>}
                                {admin && <TableCell ><Typography noWrap> <strong>APROVADO </strong></Typography></TableCell>}
                                <TableCell ><Typography noWrap> <strong> NOME</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>FORMA FARMACEUTICA</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>PRINCIPIO ACTIVO</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>CATEGORIA</strong></Typography></TableCell>
                                {(admin && solicitacao?.solicitacaoArea === "Controlados") && <TableCell ><Typography noWrap> <strong>TEOR BASE (G)	</strong></Typography></TableCell>}
                                {(admin && solicitacao?.solicitacaoArea === "Controlados") && <TableCell ><Typography noWrap> <strong>QUOTA</strong></Typography></TableCell>}
                                <TableCell ><Typography noWrap> <strong>QUANTIDADE</strong></Typography></TableCell>
                                {admin && <TableCell ><Typography noWrap> <strong>QUANTIDADE IMPORTADA</strong></Typography></TableCell>}
                                {admin && <TableCell ><Typography noWrap> <strong>DIFERENCA</strong></Typography></TableCell>}
                                <TableCell ><Typography noWrap> <strong>MOEDA</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>VALOR UNITARIO	</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>VALOR TOTAL	</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>VALOR UNITARIO EM KZ	</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>VALOR TOTAL EM KZ</strong></Typography></TableCell>
                                {/* <TableCell ><Typography noWrap> <strong>Ponto de Entrada</strong></Typography></TableCell> */}
                                <TableCell ><Typography noWrap> <strong>DATA DE FABRICO</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>DATA DE VALIDADE</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>PRECO DE VENDA</strong></Typography></TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {itens
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((item) => (
                                    <TableRow key={item?._id} className={classes.hover} >
                                        {admin && <TableCell>
                                            <Button
                                                color="secondary"
                                                size="small"
                                                onClick={() => navigate(`/admin/dmts/gest/solicitacao-de-importacao/${item?._id}/${importacaoId}`)} title={item?.nome}
                                            >
                                                <VisibilityIcon />
                                            </Button>
                                        </TableCell>}

                                        {admin && <TableCell>
                                            {item.approved ?
                                                <CheckBoxIcon color='secondary' />
                                                :
                                                load === item?._id ?
                                                    <LoadingShort />
                                                    :
                                                    <IconButton disabled={(!item?.categoria || solicitacao?.status === 'Aprovado') && temPermissao(user, ['approveProdutoListaControlados'])} onClick={() => handleApproveProducto(item?._id)}>
                                                        <CheckBoxOutlineBlankIcon />
                                                    </IconButton>
                                            }</TableCell>}

                                        <TableCell>{item?.nome}</TableCell>
                                        <TableCell>{item?.formaFarmaceutica}</TableCell>
                                        <TableCell>{item?.principioActivo}</TableCell>

                                        <TableCell><Typography noWrap>
                                            {item?.categoria}
                                            {(admin && !item?.approved && solicitacao?.status !== 'Aprovado') && <IconButton title='Editar'> <EditIcon onClick={() => setModal({ ...item, propriedade: 'categoria' })} color="secondary" fontSize='small' /></IconButton>}
                                        </Typography></TableCell>

                                        {(admin && solicitacao?.solicitacaoArea === "Controlados") && <TableCell><Typography noWrap>
                                            {item?.teorBaseG}
                                            {(!item?.approved && solicitacao?.status !== 'Aprovado') &&
                                                <IconButton title='Editar'> <EditIcon onClick={() => setModal({ ...item, propriedade: 'teorBase' })} color="secondary" fontSize='small' /></IconButton>
                                            }
                                        </Typography></TableCell>}

                                        {(admin && solicitacao?.solicitacaoArea === "Controlados") && <TableCell><Typography noWrap>
                                            {item?.quota}
                                            {(!item?.approved && solicitacao?.status !== 'Aprovado') &&
                                                <IconButton title='Editar'> <EditIcon onClick={() => setModal({ ...item, propriedade: 'quota' })} color="secondary" fontSize='small' /></IconButton>
                                            }
                                        </Typography></TableCell>}

                                        {/* {admin && <TableCell>{item?.teorBaseG}</TableCell>} */}
                                        <TableCell>{item?.quantidade}</TableCell>
                                        {admin && <TableCell>{item?.quantidadeImportada ?? '####'}</TableCell>}
                                        {admin && <TableCell>{item?.diferenca ?? '####'}</TableCell>}
                                        <TableCell>{item?.moeda ?? '####'}</TableCell>
                                        <TableCell>{item?.valorUnitario}</TableCell>
                                        <TableCell>{item?.valorTotal}</TableCell>
                                        <TableCell>{item?.valorUnitarioKZ}</TableCell>
                                        <TableCell>{item?.valorTotalKZ}</TableCell>
                                        {/* <TableCell >{item?.pontoEntrada}</TableCell> */}
                                        <TableCell><Date date={item?.dataFabrico} /></TableCell>
                                        <TableCell><Date date={item?.dataValidade} /></TableCell>
                                        <TableCell>{item?.precoRevenda}</TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        component="div"
                        count={itens?.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />

                    {/* EDITAR ITENS */}
                    <Dialog
                        open={modal}
                        // TransitionComponent={Transition}
                        // keepMounted
                        onClose={handleClose}
                        aria-describedby="alert-dialog-slide-description"
                    >
                        <DialogTitle>{modal?.nome}</DialogTitle>

                        {modal?.propriedade === 'categoria' &&
                            <AddCategoriaProducto
                                produto={modal}
                                setProduto={setModal}
                            />
                        }
                        {modal?.propriedade === 'teorBase' &&
                            <AddTeorBaseProducto
                                produto={modal}
                                setProduto={setModal}
                            />
                        }
                        {modal?.propriedade === 'quota' &&
                            <AtribuicaoQuota
                                produto={modal}
                                setProduto={setModal}
                            />
                        }

                    </Dialog>
                </>
            )}

            {itens?.length < 1 && <ListaVazia text={'NENHUM ITEM ADICIONADO'} />}
        </TableContainer>
    )
}
